import Page from './page';
import ShippingOrderDetailForm from '../components/orders/shipping-order-detail-form';

export default class ShippingOrderDetailPage extends Page {

  private readonly shippingOrderDetailForm: ShippingOrderDetailForm;
  private readonly parsleyForm: any;

  constructor(body: JQuery) {
    super();
    this.parsleyForm = $('.js-shippingOrderDetailForm').parsley();
    this.shippingOrderDetailForm = new ShippingOrderDetailForm(body.find('.js-shippingOrderDetailForm') as JQuery<HTMLFormElement>);
  }

  init(): void {
    super.init();
  }

}
